module.exports = __webpack_public_path__ + "static/media/anonym2.d58d1ea4.svg";